import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { WaitlistContext } from "@/context/waitlist";
import WaitlistModal from "@/components/WaitlistModal";
import Layout from "@/components/Layout";
import EntryPage from "@/components/EntryPage";
import AdminPage from "@/components/AdminPage";
import MemberPage from "@/components/MemberPage";
import HomePage from "@/pages/HomePage";
import SciencePage from "@/pages/SciencePage";
import ProgrammesPage from "@/pages/ProgrammesPage";
import ProductsPage from "@/pages/ProductsPage";
import TechnologyPage from "@/pages/TechnologyPage";
import ThinkingPage from "@/pages/ThinkingPage";
import ArticlePage from "@/pages/ArticlePage";
import AboutPage from "@/pages/AboutPage";
import FounderPage from "@/pages/FounderPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  const [waitlistOpen, setWaitlistOpen] = useState(false);

  return (
    <WaitlistContext.Provider value={() => setWaitlistOpen(true)}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<EntryPage />} />
            <Route path="/science" element={withLayout(<SciencePage />)} />
            <Route path="/programmes" element={withLayout(<ProgrammesPage />)} />
            <Route path="/products" element={withLayout(<ProductsPage />)} />
            <Route path="/technology" element={withLayout(<TechnologyPage />)} />
            <Route path="/thinking" element={withLayout(<ThinkingPage />)} />
            <Route path="/thinking/:slug" element={withLayout(<ArticlePage />)} />
            <Route path="/about" element={withLayout(<AboutPage />)} />
            <Route path="/founder" element={withLayout(<FounderPage />)} />
            <Route path="/contact" element={withLayout(<ContactPage />)} />
            <Route path="/privacy" element={withLayout(<LegalPage kind="privacy" />)} />
            <Route path="/terms" element={withLayout(<LegalPage kind="terms" />)} />
            <Route path="/disclaimer" element={withLayout(<LegalPage kind="disclaimer" />)} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/member" element={<MemberPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <WaitlistModal open={waitlistOpen} onClose={() => setWaitlistOpen(false)} />
        </BrowserRouter>
      </div>
    </WaitlistContext.Provider>
  );
}

export default App;
